import { BaseProviderInstanceResourceModel } from '../base-provider-instance-resource-model';

export class ReportProfileResource {
  providerInstanceResource: BaseProviderInstanceResourceModel;
  isValid: boolean;
}
